import store from "../../config/store";
import { PlugBoletoApi } from "../../external";

class PlugBoletoService {
  constructor() {
    this.urlBase = "plug-boleto";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  cadastrarCedente(body) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/cedentes`).post(body);
  }

  cadastrarConta(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/cedentes/contas`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }

  atualizarConta(id, body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/cedentes/contas`).put(
      id,
      body,
      { "cnpj-cedente": cedente },
    );
  }

  cadastrarConvenio(body, cedente) {
    return new PlugBoletoApi(
      `${this.urlBaseCompleta}/cedentes/contas/convenios`,
    ).post(body, { "cnpj-cedente": cedente });
  }

  atualizarConvenio(id, body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/cedentes/contas/convenios`).put(
      id,
      body,
      { "cnpj-cedente": cedente },
    );
  }

  removerConvenio(id, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/cedentes/contas/convenios`).delete(
      id,
      { "cnpj-cedente": cedente },
    );
  }

  incluirBoletosLote(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/boletos/lote`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }

  imprimirBoleto(idImpressao, cedente) {
    return new PlugBoletoApi(
      `${this.urlBaseCompleta}/boletos/impressao/${idImpressao}`,
    ).get({ "cnpj-cedente": cedente });
  }

  gerarRemessa(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/remessas/lote`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }

  descartarEmLote(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/boletos/descarta/lote`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }

  baixarEmLote(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/boletos/baixa/lote`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }

  consultarSituacao(params, cedente) {
    return new PlugBoletoApi(
      `${this.urlBaseCompleta}/boletos?${params}`,
    ).get({ "cnpj-cedente": cedente });
  }

  processarRetorno(body, cedente) {
    return new PlugBoletoApi(`${this.urlBaseCompleta}/retornos`).post(
      body,
      { "cnpj-cedente": cedente },
    );
  }
}

export default PlugBoletoService;
